import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { formatNumber } from '@atc/string-fns';

/**
 *  FilteredResultsText component rendders the text protion of the filtered results.
 *
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const renderResults = _ref => {
  let {
    numRecordsData,
    maxResultCount,
    pageCount,
    resultCount,
    supplementalListings,
    showSupplementalResults
  } = _ref;
  const itemsPerPageMax = numRecordsData && numRecordsData.value || 25;
  const hasMEE = showSupplementalResults && supplementalListings.length > 0;
  const getNumbThru = () => {
    let numthru = Math.abs(pageCount) * itemsPerPageMax || itemsPerPageMax;
    if (numthru >= resultCount || numthru < itemsPerPageMax) {
      numthru = resultCount;
    }
    return numthru;
  };
  if (maxResultCount && getNumbThru() >= maxResultCount) {
    return 'You have reached the maximum results allowed for a search. Please update your search criteria.';
  }
  const styleNumber = value => /*#__PURE__*/_jsx("span", {
    className: "text-bold",
    children: formatNumber({
      value
    })
  });
  const resultsLabel = !hasMEE && /*#__PURE__*/_jsxs(_Fragment, {
    children: ["You have viewed", ' ', styleNumber(getNumbThru()), ' ', "of", ' ', styleNumber(resultCount), ' ', "Results"]
  });
  if (resultCount <= 0) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Showing", ' ', styleNumber(0), ' ', "Results"]
    });
  }
  if (resultCount === 1) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: ["Showing", ' ', styleNumber(1), ' ', "Result"]
    });
  }
  return resultsLabel;
};
function FilteredResultsText(_ref2) {
  let {
    className,
    maxResultCount,
    numRecordsData,
    pageCount = 1,
    resultCount = 0,
    supplementalListings,
    showSupplementalResults,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('results-text-container', className),
    ...rest,
    children: renderResults({
      numRecordsData,
      maxResultCount,
      pageCount,
      resultCount,
      supplementalListings,
      showSupplementalResults
    })
  });
}
export default FilteredResultsText;